import api from "./api";

export const evaluateAdaptiveSecurity = async (events) => {
    const res = await api.post("/adaptivesecurity/evaluate", events);
    return res.data;
};

export default {
    evaluateAdaptiveSecurity,
};